import { Mark, Node } from '@tiptap/pm/model';
import { RlCustomSectionName } from '../extensions/custom-block-node-names';

const compareMarks = (marks1: Mark[], marks2: Mark[]) => {
  if (marks1.length !== marks2.length) {
    return false;
  }

  return marks1.every((mark1, i) => {
    const mark2 = marks2[i];

    return (
      mark1.type === mark2.type &&
      JSON.stringify(mark1.attrs) === JSON.stringify(mark2.attrs)
    );
  });
};

interface CompareOptions {
  compareOnly?: Array<'type' | 'content' | 'marks' | 'attrs'>;
  compareAttrs?: string[];
}
const advancedCompareNodes = (
  node1: Node,
  node2: Node,
  options: CompareOptions = {},
) => {
  const { compareOnly, compareAttrs } = options;
  const compareAttributes = () => {
    if (compareAttrs) {
      return compareAttrs.every(
        (attr) => node1.attrs[attr] === node2.attrs[attr],
      );
    }

    return JSON.stringify(node1.attrs) === JSON.stringify(node2.attrs);
  };

  if (compareOnly) {
    return compareOnly.every((aspect) => {
      switch (aspect) {
        case 'type':
          return node1.type === node2.type;
        case 'content':
          return node1.textContent === node2.textContent;
        case 'marks':
          return compareMarks([...node1.marks], [...node2.marks]);
        case 'attrs':
          return compareAttributes();
        default:
          return true;
      }
    });
  }

  // Default full comparison
  return node1.eq(node2);
};

export const compareNodes = (
  node1: Node,
  node2: Node,
  options: CompareOptions = {},
) => {
  if (node1.type.name !== node2.type.name) {
    return false;
  }

  if (node1.type.name === RlCustomSectionName) {
    return advancedCompareNodes(node1, node2, {
      compareAttrs: ['templateSectionId', 'documentSectionId'],
      compareOnly: ['attrs'],
    });
  }

  return advancedCompareNodes(node1, node2, options);
};
